import {_Permissions} from "./permissions";

export class Roles {
    id?:number;
    nom?:RoleName;
    description?:string;
    // permissions: _Permissions[]
}

export enum RoleName {
    ROLE_ADMIN = 'ROLE_ADMIN',
    ROLE_INTERN = 'ROLE_INTERN',
    ROLE_SELLER = 'ROLE_SELLER',
    ROLE_ACCOUNTANT = 'ROLE_ACCOUNTANT',
    ROLE_STOCK_MANAGER = 'ROLE_STOCK_MANAGER',

}
